import LogRocket from 'logrocket';
import { EventEmitter } from '@angular/core';

import { setTitle } from 'Utils';
import EquipmentDataUsageModal from './equipmentDataUsage/EquipmentDataUsage.modal';
import template from './dashboard.html';
import _ from 'lodash';

/* @ngInject */
function DashboardController(
  $scope,
  $timeout,
  $window,
  $state,
  $uibModal,
  $stateParams,
  $location,
  growl,
  EquipmentInfoService,
  DashboardInfoService,
  GroupService,
  GroupsButtonService,
  ModalService,
  DashboardService,
  ResponsiveBreakpoints,
  PanelTypes,
  UserInfoService
) {
  const vm = this;
  const RESIZE_DEBOUNCE = 500;

  const dashHasEquipment = dashboard => _.get(dashboard, 'equipment.length', 0) > 0;

  vm.user = UserInfoService.getCurrentUser();
  vm.currentResponsiveBreakpoint = 'desktop';

  vm.severities = [{
    id: 'warn',
    name: 'Warning'
  }, {
    id: 'error',
    name: 'Error'
  }, {
    id: 'success',
    name: 'Success'
  }, {
    id: 'info',
    name: 'Information'
  }];

  let mobileMediaQuery = $window.matchMedia(ResponsiveBreakpoints.mobile.mediaQuery);
  let smallTabletMediaQuery = $window.matchMedia(ResponsiveBreakpoints.smallTablet.mediaQuery);
  let largeTabletMediaQuery = $window.matchMedia(ResponsiveBreakpoints.largeTablet.mediaQuery);
  let desktopMediaQuery = $window.matchMedia(ResponsiveBreakpoints.desktop.mediaQuery);

  vm.gridsterOptions = {
    columns: 12,
    maxRows: 1000, // This is some arbitrarily large value to prevent overflow for (long) mobile grids
    swapping: true,
    floating: false,
    sparse: true, // May increase performance for larger grids when dragging and resizing
    mobileModeEnabled: false,
    resizable: {
      stop: gridsterResizeStop,
      start: gridsterResizeStart,
      handles: ['se', 'sw']
    },
    draggable: {
      enabled: false,
      handle: '.drag-handle',
      stop: gridsterDragStop,
      start: gridsterDragStart
    }
  };

  vm.gridster = {
    gridsterDomIsReady: {}
  };

  vm.growlMessageSave = null;

  /**
   * setting PanelTypes to scope variable so that gridster can use it
   */
  vm.PanelTypes = angular.copy(PanelTypes);

  const dashboardLayoutConfig =
    'DashCtrl.currentDashboard.dashboardLayout.layout[panel.id].modes[DashCtrl.currentResponsiveBreakpoint]';
  const panelTypesConfig =
    'DashCtrl.PanelTypes[panel.type].modes[DashCtrl.currentResponsiveBreakpoint]';
  vm.customPanelMapping = {
    row: `${dashboardLayoutConfig}.row`,
    col: `${dashboardLayoutConfig}.col`,
    sizeX: `${dashboardLayoutConfig}.sizeX`,
    sizeY: `${dashboardLayoutConfig}.sizeY`,
    minSizeX: `${panelTypesConfig}.minSizeX`,
    minSizeY: `${panelTypesConfig}.minSizeY`,
    maxSizeX: `${panelTypesConfig}.maxSizeX`,
    maxSizeY: `${panelTypesConfig}.maxSizeY`
  };

  vm.currentDashboard = null;
  let gridsterDragWatch = null;
  let savedDashboardLayout;
  vm.groupList = null;
  vm.selectedGroups = [];
  vm.notifyMessagesChange = new EventEmitter();

  vm.$onInit = init;
  vm.$onDestroy = destroy;
  vm.editDashboard = editDashboard;
  vm.getDefaultLayout = getDefaultLayout;
  vm.getUserLayout = getUserLayout;
  vm.saveLayoutTemplate = saveLayoutTemplate;

  function init() {
    if ($stateParams.id === 'new') {
      vm.currentDashboard = DashboardService.createNewDashboard();
      editDashboard();
      setDashboardMessages();
    } else {
      DashboardService.getDashboardDetailsFromServer($stateParams.id)
        .then(async (dashboard) => {
          startGridsterDragWatch();
          savedDashboardLayout = _.cloneDeep(dashboard.dashboardLayout.layout);

          // Filter out panels where user has no access to any of the equipment
          await filterPanelsByEquipmentAccess(dashboard);

          dashboard.equipment = DashboardInfoService.getEquipment(dashboard);

          vm.currentDashboard = dashboard;
          $scope.currentDashboard = dashboard; // TODO: delete when all panels no longer need scope
          // populate object of active panels that need to have domReady for
          // gridster dragging handle
          angular.forEach(vm.currentDashboard.panels, (panel, panelId) => {
            vm.gridster.gridsterDomIsReady[panelId] = !panel.deleted;
          });

          subscribeToEquipment(dashboard);
          setupGroups();
          $timeout(() => {
            vm.gridsterOptions.floating = true;
          }, 30);

          // Update page title with dashboard name
          setTitle(dashboard.dashboard.name);
          setDashboardMessages();
        });
    }

    handleScreenSizeChangeForMobile(mobileMediaQuery);
    handleScreenSizeChangeForSmallTablet(smallTabletMediaQuery);
    handleScreenSizeChangeForLargeTablet(largeTabletMediaQuery);
    handleScreenSizeChangeForDesktop(desktopMediaQuery);

    vm.isAuthorizedToConfig = UserInfoService.isCurrentUserPartner();
    vm.isAuthorizedToSetTemplate = UserInfoService.isCurrentUserAdmin();
    vm.isAuthorizedToSetMessages = UserInfoService.isCurrentUserSuperAdmin();
  }

  function setDashboardMessages() {
    vm.currentDashboard.messages = vm.currentDashboard.messages || [];
  }

  function destroy() {
    if (dashHasEquipment(vm.currentDashboard)) {
      EquipmentInfoService.unsubscribeToGivenEquipment(vm.currentDashboard.equipment);
    }

    mobileMediaQuery.removeListener(handleScreenSizeChangeForMobile);
    smallTabletMediaQuery.removeListener(handleScreenSizeChangeForSmallTablet);
    largeTabletMediaQuery.removeListener(handleScreenSizeChangeForLargeTablet);
    desktopMediaQuery.removeListener(handleScreenSizeChangeForDesktop);

    mobileMediaQuery = null;
    smallTabletMediaQuery = null;
    largeTabletMediaQuery = null;
    desktopMediaQuery = null;

    stopGridsterDragWatch();
    stopGroupsChangeWatch();
  }

  function startGridsterDragWatch() {
    if (!gridsterDragWatch) {
      gridsterDragWatch = $scope.$watch('DashCtrl.gridster.gridsterDomIsReady', (newVal) => {
        let allGood = false;
        const values = _.values(newVal);

        for (let i = 0, len = values.length; i < len; i += 1) {
          if (values[i]) {
            allGood = true;
          } else {
            allGood = false;
            break;
          }
        }
        if (allGood) {
          vm.gridsterOptions.draggable.enabled = true;
        }
      }, true);
    }
  }

  function stopGridsterDragWatch() {
    if (gridsterDragWatch) {
      gridsterDragWatch();
      gridsterDragWatch = null;
    }
  }

  let groupsChangeWatch = null;

  function startGroupsChangeWatch() {
    if (!groupsChangeWatch) {
      groupsChangeWatch = $scope.$watch(() => _.get(vm.selectedGroups, 'length'), (newVal, oldVal) => {
        if (newVal !== oldVal) {
          vm.currentDashboard.hasBeenChanged = true;
        }
      });
    }
  }

  function stopGroupsChangeWatch() {
    if (groupsChangeWatch) {
      groupsChangeWatch();
      groupsChangeWatch = null;
    }
  }

  /**
   * Filter out panels where the user has no access to any of the panel's equipment.
   * This prevents showing empty panels when the user lacks permission to view the equipment.
   *
   * @param {object} dashboard - The dashboard object with panels
   */
  async function filterPanelsByEquipmentAccess(dashboard) {
    const allEquipmentIds = DashboardInfoService.getEquipment(dashboard);
    if (_.isEmpty(allEquipmentIds)) {
      return;
    }

    // Fetch accessible equipment - API only returns equipment user has permission to see
    const accessibleEquipment = await EquipmentInfoService.getEquipmentById(allEquipmentIds);
    const accessibleIds = new Set(_.map(_.castArray(accessibleEquipment), 'id'));

    // Filter panels: keep only panels where at least one equipment is accessible
    // or panels that have no equipment assigned (these show "needs configuration" message)
    _.forEach(dashboard.panels, (panel, panelId) => {
      const panelEquipment = panel.equipment || [];
      const hasAccessibleEquipment = _.isEmpty(panelEquipment) ||
        panelEquipment.some(eqId => accessibleIds.has(eqId));

      if (!hasAccessibleEquipment) {
        // Mark panel as deleted so it won't be rendered
        dashboard.panels[panelId].deleted = true;
      }
    });
  }

  function subscribeToEquipment(dashboard) {
    if (dashHasEquipment(dashboard)) {
      EquipmentInfoService.subscribeToGivenEquipment(dashboard.equipment);
    }
  }

  function setupGroups() {
    vm.selectedGroups = vm.currentDashboard.dashboard.groups;
  }

  function gridsterResizeStart(__, $element) {
    const elem = $element[0];
    $scope.$broadcast(`gridster-resize-start-${elem.id}`);
    setBoxShadow(elem);
  }

  function gridsterResizeStop(__, $element, uiWidget) {
    const elem = $element[0];
    $scope.$broadcast(`gridster-resize-stop-${elem.id}`);

    enforceMinimumPanelSize(uiWidget);
    vm.panelResized();
    updateDashboardLayout();
    unsetBoxShadow(elem);
  }

  function gridsterDragStart(__, $element) {
    const elem = $element[0];
    $scope.$broadcast(`gridster-drag-start-${elem.id}`);
    setBoxShadow(elem);
  }

  function gridsterDragStop(__, $element) {
    const elem = $element[0];
    $scope.$broadcast(`gridster-drag-stop-${elem.id}`);
    /* TODO:
       Update should NOT be called unless there is an actual change to the dashboard
       This posts to the API even if the panel is picked up and dropped in the same place
       Or even just clicking the panel's header
    */
    updateDashboardLayout();
    unsetBoxShadow(elem);
  }

  function setBoxShadow(element) {
    element.classList.remove('drop');
    element.classList.add('lift');
  }

  function unsetBoxShadow(element) {
    element.classList.remove('lift');
    element.classList.add('drop');
  }

  // enforces a minimum size for each panel based on the minSizeX/Y in the current screen mode
  // values are stored in the layout object modes
  function enforceMinimumPanelSize(uiWidget) {
    if (uiWidget.sizeX < uiWidget.minSizeX) {
      uiWidget.setSizeX(uiWidget.minSizeX);
    }
    if (uiWidget.sizeY < uiWidget.minSizeY) {
      uiWidget.setSizeY(uiWidget.minSizeY);
    }
  }

  function handleScreenSizeChangeForMobile(mobileMediaQ) {
    if (mobileMediaQ.matches) {
      vm.currentResponsiveBreakpoint = 'mobile';
    }
  }

  mobileMediaQuery.addListener(handleScreenSizeChangeForMobile);

  function handleScreenSizeChangeForSmallTablet(smallTabletMediaQ) {
    if (smallTabletMediaQ.matches) {
      vm.currentResponsiveBreakpoint = 'smallTablet';
    }
  }

  smallTabletMediaQuery.addListener(handleScreenSizeChangeForSmallTablet);

  function handleScreenSizeChangeForLargeTablet(largeTabletMediaQ) {
    if (largeTabletMediaQ.matches) {
      vm.currentResponsiveBreakpoint = 'largeTablet';
    }
  }

  largeTabletMediaQuery.addListener(handleScreenSizeChangeForLargeTablet);

  function handleScreenSizeChangeForDesktop(desktopMediaQ) {
    if (desktopMediaQ.matches) {
      vm.currentResponsiveBreakpoint = 'desktop';
    }
  }

  desktopMediaQuery.addListener(handleScreenSizeChangeForDesktop);

  vm.panelResized = () => {
    $scope.$broadcast('panel-resized');
  };

  async function getDefaultLayout() {
    const defaultLayout = await DashboardService.getLayout(vm.currentDashboard.dashboard.id, 'default');
    if (_.isEmpty(defaultLayout)) {
      growl.error('Default Layout Template has not been created yet for this Dashboard');
    } else {
      vm.currentDashboard.dashboardLayout = defaultLayout;
      growl.success('Dashboard Layout Reset to Default');
    }
  }

  async function getUserLayout() {
    const defaultLayout = await DashboardService.getLayout(vm.currentDashboard.dashboard.id);
    vm.currentDashboard.dashboardLayout = defaultLayout;
    growl.success('Dashboard Layout Reset to Custom');
  }

  async function saveLayoutTemplate() {
    if (vm.currentDashboard.dashboard.defaultLayout) {
      await ModalService.confirmationModal({
        modalTitle: 'Are sure you want to save this layout as default?',
        optionalWarning: 'This action will overwrite the existing default layout.'
      });
    }

    // currently the only template that can be used is 'default'
    // eventually we will allow the option for different templates i.e. 'eventPanelsFirst', 'camPanelsFirst'
    const layoutTemplate = 'default';
    try {
      await DashboardService.updateLayout(layoutTemplate);
      growl.success(`${layoutTemplate} Layout saved successfully for this dashboard`);
    } catch (err) {
      growl.error(err.error, { title: `Could not save ${layoutTemplate} layout` });
    }
  }

  function updateDashboardLayout() {
    if (!_.isMatch(savedDashboardLayout, vm.currentDashboard.dashboardLayout.layout)) {
      DashboardService.updateLayout();
      savedDashboardLayout = _.cloneDeep(vm.currentDashboard.dashboardLayout.layout);
      growl.success('Custom Layout Saved');
    }
  }

  /**
   * edit dashboards
   */

  vm.confirmActionModel = {
    showState: false,
    message: '',
    messageClass: 'alert-danger',
    confirmFunction: null
  };

  function editDashboard() {
    GroupService.getGroupTree(true).then(({ data }) => { vm.groupList = data });

    stopGridsterDragWatch();
    stopGroupsChangeWatch();
    vm.gridsterOptions.draggable.enabled = false;
    vm.gridsterOptions.resizable.enabled = false;

    vm.currentDashboard = DashboardService.setDashboardToEdit(vm.currentDashboard);
    $scope.currentDashboard = vm.currentDashboard; // TODO: delete when all panels no longer need scope

    startGridsterDragWatch();
    startGroupsChangeWatch();
  }

  function cancelEditDashboard() {
    stopGroupsChangeWatch();
    DashboardService.cancelEditDashboard();
    // call the cancel to reset the showing of the confirm message
    vm.cancelConfirmAction();
    startGridsterDragWatch();
    vm.gridsterOptions.resizable.enabled = true;
    if ($stateParams.id === 'new') {
      $location.path('/');
    } else {
      $state.reload();
    }
  }

  async function saveDashboard() {
    try {
      const dashboardId = await DashboardService.saveDashboard();
      updateGrowlMessage('success', 'Dashboard saved successfully!');

      if ($stateParams.id === 'new') {
        $location.path(`/dashboard/${dashboardId}`);
      } else {
        $state.reload();
      }
    } catch (res) {
      const error = 'Error saving dashboard';
      updateGrowlMessage('error', res.error, { title: error });
      LogRocket.track(error);
    }
  }

  async function validateAndSaveDashboard() {
    const dashboard = vm.currentDashboard.dashboard;
    const invalidMessages = findInvalidMessages();

    if (!dashboard.name) {
      return updateGrowlMessage('warning', 'The dashboard must have a name.');
    }

    if (invalidMessages?.length > 0) {
      return updateGrowlMessage('warning', 'The messages must have title and detail associated with them.');
    }

    if (!dashboard.groups.length) {
      return updateGrowlMessage('warning', 'The dashboard must have at least one group associated with it.');
    }

    if (dashboard.groups.length === 1) {
      const group = await GroupService.getGroup(dashboard.groups[0]);
      if (!group.parent) {
        return updateGrowlMessage('warning', `The group cannot be the top group: '${group.name}'.`);
      }
    }

    saveDashboard();
  }

  function findInvalidMessages(messages = vm.currentDashboard.messages) {
    return messages
      .map((message, index) => ({
        index,
        invalid: !message.summary || !message.summary.trim() || !message.detail || !message.detail.trim()
      }))
      .filter(item => item.invalid)
      .map(item => item.index);
  }

  function updateGrowlMessage(type, message, options) {
    if (vm.growlMessageSave) {
      vm.growlMessageSave.destroy();
    }
    vm.growlMessageSave = growl[type](message, options);
  }

  vm.saveEditDashboard = () => {
    vm.growlMessageSave = growl.info('Saving dashboard...', { disableCloseButton: true });
    stopGroupsChangeWatch();

    const groups = [];
    vm.selectedGroups = GroupsButtonService.rebuildSelectedGroups();
    angular.forEach(vm.selectedGroups, (group) => {
      groups.push(group.id);
    });
    vm.currentDashboard.dashboard.groups = groups;
    validateAndSaveDashboard();
  };

  vm.confirmDeleteDashboard = () => {
    vm.confirmActionModel.message = 'Are you sure you want to delete this dashboard?';
    vm.confirmActionModel.messageClass = 'alert-danger';
    vm.confirmActionModel.confirmFunction = deleteDashboard;
    vm.confirmActionModel.showState = true;
  };

  vm.confirmDiscardChanges = () => {
    if (vm.currentDashboard.hasBeenChanged) {
      vm.confirmActionModel.message = 'Are you sure you want to discard unsaved changes?';
      vm.confirmActionModel.messageClass = 'alert-warning';
      vm.confirmActionModel.confirmFunction = cancelEditDashboard;
      vm.confirmActionModel.showState = true;
    } else {
      cancelEditDashboard();
    }
  };

  vm.cancelConfirmAction = () => {
    vm.confirmActionModel = {
      showState: false,
      message: '',
      messageClass: 'alert-danger',
      confirmFunction: null
    };
  };

  // Function to add a new message to the array
  vm.addMessage = () => {
    vm.currentDashboard.messages.push({
      summary: '',
      severity: '',
      detail: ''
    });

    vm.triggerNotifyMessagesChange();
  };

  // Function to remove a message from the array
  vm.removeMessage = (index) => {
    if (index >= 0 && index < vm.currentDashboard.messages.length) {
      vm.currentDashboard.messages.splice(index, 1);
      vm.triggerNotifyMessagesChange();
    }
  };

  vm.triggerNotifyMessagesChange = () => {
    vm.notifyMessagesChange.emit({
      messages: vm.currentDashboard.messages
    });
  };

  function deleteDashboard() {
    let growlMessage = growl.info('Deleting dashboard...', { disableCloseButton: true });
    DashboardService.deleteDashboard()
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Dashboard deleted successfully!');
        $location.path('/');
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error Deleting Dashboard';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  vm.toggleEditGroup = () => {
    vm.editGroups.editState = !vm.editGroups.editState;
  };

  vm.editPanelsModal = () => {
    DashboardService.openEditPanelModal(null);
  };

  vm.openUsageModal = () => {
    $uibModal.open({
      ...EquipmentDataUsageModal,
      size: 'lg',
      resolve: {
        equipment: () => vm.currentDashboard.equipment
      }
    });
  };
}

export default {
  name: 'dashboardComponent',
  template,
  controller: DashboardController,
  controllerAs: 'DashCtrl'
};
